// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"41a1492f","949":"41a1492f"}[chunkId] + ".chunk.css";
};